import { esGerenteDeOperaciones } from "./gerenteOperaciones";

export const MODULE_PERMISSIONS_STORAGE_KEY = "module_permissions_v1";

export const MODULE_PERMISSIONS_ADMIN_CEDULA = "5355286";

export type LegacyRoleKey =
  | "operario"
  | "fiscal"
  | "supervisor"
  | "jefe_operaciones"
  | "gerente_operaciones"
  | "lider_agentis"
  | "tic"
  | "desarrollador"
  | "gerente_ti"
  | "gerente_general_adjunto"
  | "capacitador_tecnico"
  | "coordinador_capacitaciones";

export interface RoleDefinition {
  key: LegacyRoleKey;
  label: string;
}

export interface ModuleDefinition {
  id: string;
  title: string;
  description: string;
  paths: string[];
}

export type ModulePermissionsMap = Record<string, Record<string, boolean>>;

export const ROLE_DEFINITIONS: RoleDefinition[] = [
  { key: "operario", label: "Operario" },
  { key: "fiscal", label: "Fiscal" },
  { key: "supervisor", label: "Supervisor" },
  { key: "jefe_operaciones", label: "Jefe de Operaciones" },
  { key: "gerente_operaciones", label: "Gerente de Operaciones" },
  { key: "lider_agentis", label: "Lider Agentis" },
  { key: "tic", label: "TIC" },
  { key: "desarrollador", label: "Desarrollador" },
  { key: "gerente_ti", label: "Gerente de TI" },
  { key: "gerente_general_adjunto", label: "Gerente General Adjunto" },
  { key: "capacitador_tecnico", label: "Capacitador Tecnico" },
  { key: "coordinador_capacitaciones", label: "Coordinador de Capacitaciones Tecnicas" },
];

const LEGACY_ROLE_KEYS = ROLE_DEFINITIONS.map((role) => role.key);
const TODOS_MENOS_OPERARIO = LEGACY_ROLE_KEYS.filter((key) => key !== "operario");

const allowRoles = (enabled: LegacyRoleKey[]): Record<LegacyRoleKey, boolean> => {
  const set = new Set(enabled);
  return LEGACY_ROLE_KEYS.reduce((acc, role) => {
    acc[role] = set.has(role);
    return acc;
  }, {} as Record<LegacyRoleKey, boolean>);
};

export const MODULE_DEFINITIONS: ModuleDefinition[] = [
  { id: "home", title: "Inicio", description: "Pantalla principal de bienvenida", paths: ["/home"] },
  { id: "marcacion", title: "Marcacion", description: "Registro de marcaciones", paths: ["/marcar"] },
  { id: "historial", title: "Historial de trabajo", description: "Consulta de historial personal", paths: ["/historial-de-trabajo"] },
  { id: "reclamos", title: "Reclamos de horas", description: "Gestion y seguimiento de reclamos", paths: ["/reclamos"] },
  { id: "salarios", title: "Recibos salariales", description: "Acceso a recibos de pago", paths: ["/salarios"] },
  { id: "reembolso_pasajes", title: "Reembolso de Pasajes", description: "Reembolsos de pasajes de bus entre puntos de servicio", paths: ["/reembolsos-pasajes"] },
  { id: "mis_asignaciones", title: "Mis Asignaciones", description: "Asignaciones del operario", paths: ["/mis-asignaciones"] },
  { id: "mis_reemplazos", title: "Mis Reemplazos", description: "Reemplazos asignados al operario", paths: ["/mis-reemplazos"] },
  { id: "gestiones", title: "Gestiones", description: "Modulo operativo de gestiones", paths: ["/gestiones", "/asignacionDetalle", "/AsignacionDTEdicion"] },
  {
    id: "fiscalizacion",
    title: "Fiscalizacion",
    description: "Ejecucion de fiscalizacion en puntos de servicio",
    paths: [
      "/fiscalizacion",
      "/fiscalizarinicio",
      "/fiscalizarpersonal",
      "/fiscalizardeposito",
      "/fiscalizarmaquina",
      "/fiscalizarlimpieza",
      "/fiscalizaropinion",
      "/fiscalizarstock",
      "/resumenfiscalizacion",
    ],
  },
  { id: "asignacion_recursos", title: "Asignacion de Recursos", description: "Administracion de recursos por fiscalizacion", paths: ["/asignacion-recursos"] },
  {
    id: "pedido_productos",
    title: "Pedido de Productos",
    description: "Solicitudes y gestion de pedidos",
    paths: ["/pedido-de-productos", "/pedido-de-productos-detalles", "/mis-pedidos"],
  },
  { id: "planificacion_visitas", title: "Planificacion de Visitas", description: "Organizacion semanal de visitas", paths: ["/planificacion-visitas"] },
  { id: "limpiezas_profundas", title: "Limpiezas Profundas", description: "Seguimiento de planificaciones de limpieza", paths: ["/limpiezas-profundas"] },
  { id: "acompanamiento", title: "Acompanamiento", description: "Seguimiento de acompanamientos", paths: ["/acompanamiento"] },
  { id: "reemplazos", title: "Reemplazos", description: "Gestion de reemplazos", paths: ["/reemplazos-v2"] },
  { id: "notificacion_reemplazos", title: "Notificacion de Reemplazos", description: "Estado de confirmacion de reemplazos por punto de servicio", paths: ["/notificacion-reemplazos"] },
  { id: "mis_casos", title: "Mis Casos", description: "Bandeja de casos de ausencias del fiscalizador", paths: ["/mis-casos"] },
  { id: "asignaciones_v2", title: "Asignaciones (nuevo)", description: "Asignacion de operarios estilo EMSYS con IA", paths: ["/asignaciones-v2", "/asignaciones-v2-detalle"] },
  { id: "sugerencia_ps", title: "Sugerencia por Geolocalizacion", description: "PS mas cercanos a la casa de cada operario y operarios mas cercanos a un PS (reporte de EMSYS)", paths: ["/sugerencia-ps"] },
  { id: "evaluacion_desempeno", title: "Evaluacion de Desempeno", description: "Evaluaciones de operarios y supervisores", paths: ["/evaluacion-de-desempeno"] },
  { id: "reporte_eval_desempeno", title: "Reporte Eval. Desempeno", description: "Reporte jerarquico de evaluaciones", paths: ["/evaluacion-de-desempeno/reporte"] },
  { id: "evaluacion_visitas", title: "Evaluacion Visitas", description: "Modulo de evaluacion de visitas", paths: ["/evaluacion-visitas"] },
  { id: "relevamiento_visitas", title: "Visitas Comercial", description: "Modulo comercial de visitas", paths: ["/relevamiento-visitas"] },
  { id: "visitas_unidades_especializadas", title: "Visitas Unidades Especializadas", description: "Visitas para gerente/lider/fiscalizadores de unidades especializadas", paths: ["/visitas-unidades-especializadas"] },
  { id: "evaluacion_capacitacion", title: "Evaluacion Capacitacion", description: "Evaluaciones de capacitaciones tecnicas", paths: ["/evaluacion-capacitacion"] },
  { id: "asignaciones_capacitador", title: "Asignaciones (consulta)", description: "Consulta de asignaciones por punto de servicio o por persona (capacitador tecnico, su coordinador y jefe de operaciones)", paths: ["/asignaciones-capacitador"] },
  { id: "registro_capacitacion", title: "Registro de Capacitacion", description: "Registro de capacitaciones tecnicas realizadas", paths: ["/registro-capacitacion"] },
  { id: "historial_capacitacion", title: "Historial de Capacitaciones", description: "Consulta del historial de capacitaciones", paths: ["/historial-capacitacion"] },
  { id: "clima_organizacional", title: "Clima Organizacional", description: "Encuesta de clima organizacional", paths: ["/clima-organizacional"] },
  { id: "cierre_diario", title: "Cierre Diario", description: "Cierre operativo diario", paths: ["/cierre-diario", "/CierreDiario", "/CierreDiarioMensajeRechazo"] },
  { id: "servicios_especializados", title: "Servicios Especializados", description: "Gestion de servicios especializados", paths: ["/servicios-especializados"] },
  { id: "recursos", title: "Recursos", description: "Biblioteca de capacitaciones y material", paths: ["/recursos"] },
  { id: "nosotros", title: "Sobre Nosotros", description: "Informacion institucional y documentaciones", paths: ["/nosotros", "/documentaciones"] },
  { id: "denuncias", title: "Denuncias", description: "Canal de denuncias", paths: ["/denuncias"] },
  {
    id: "solicitudes",
    title: "Solicitudes",
    description:
      "Puerta de entrada del modulo: elegir a que departamento se le pide",
    paths: ["/solicitudes"],
  },
  {
    id: "solicitudes_rrhh",
    title: "Solicitudes a RRHH",
    description: "Carga de solicitudes a RRHH (migracion del proceso de Flokzu)",
    paths: ["/solicitudes-rrhh"],
  },
  {
    id: "solicitudes_capacitacion",
    title: "Solicitudes de Capacitacion",
    description:
      "Solicitud de capacitaciones tecnicas a Gestion de Talento (fiscales/supervisores) y cierre por el capacitador",
    paths: ["/solicitudes-capacitacion"],
  },
  {
    id: "solicitudes_sst",
    title: "Solicitudes a SST",
    description: "Pedidos a Seguridad y Salud en el Trabajo; SST los gestiona en EMSYS",
    paths: ["/sst/solicitudes"],
  },
  {
    id: "solicitudes_gafcore",
    title: "Solicitudes a GafCORE",
    description: "Traslados de activos y mantenimiento correctivo; los atiende GAF en GafCORE",
    paths: ["/gafcore"],
  },
];

const LEGACY_DEFAULTS: ModulePermissionsMap = {
  home: allowRoles(LEGACY_ROLE_KEYS),
  marcacion: allowRoles(LEGACY_ROLE_KEYS),
  historial: allowRoles(LEGACY_ROLE_KEYS),
  reclamos: allowRoles(LEGACY_ROLE_KEYS),
  salarios: allowRoles(LEGACY_ROLE_KEYS),
  reembolso_pasajes: allowRoles(["operario"]),
  mis_asignaciones: allowRoles(["operario"]),
  mis_reemplazos: allowRoles(["operario"]),
  gestiones: allowRoles(["fiscal"]),
  fiscalizacion: allowRoles(["fiscal", "gerente_general_adjunto"]),
  asignacion_recursos: allowRoles(["fiscal"]),
  // El Analista Sr. de Operaciones entra como jefatura (src/config/cargoPedido.ts).
  pedido_productos: {
    ...allowRoles(["fiscal", "jefe_operaciones", "gerente_operaciones", "lider_agentis"]),
    "ANALISTA SR. DE OPERACIONES": true,
  },
  planificacion_visitas: allowRoles(["fiscal", "jefe_operaciones", "gerente_operaciones"]),
  limpiezas_profundas: allowRoles(["fiscal", "jefe_operaciones", "gerente_operaciones"]),
  acompanamiento: allowRoles(["jefe_operaciones", "tic", "desarrollador", "gerente_ti"]),
  reemplazos: allowRoles(["fiscal", "jefe_operaciones", "tic", "desarrollador", "gerente_ti"]),
  notificacion_reemplazos: allowRoles(["fiscal", "jefe_operaciones", "gerente_operaciones", "supervisor", "lider_agentis"]),
  mis_casos: allowRoles(["fiscal"]),
  asignaciones_v2: allowRoles(["fiscal"]),
  // Gerente y Jefe de Operaciones, Analista Sr. de Operaciones y fiscales
  // (src/config/sugerenciaPs.ts). api-central y EMSYS revalidan el cargo.
  sugerencia_ps: {
    ...allowRoles(["fiscal", "jefe_operaciones", "gerente_operaciones"]),
    "ANALISTA SR. DE OPERACIONES": true,
  },
  evaluacion_desempeno: allowRoles([
    "fiscal",
    "jefe_operaciones",
    "supervisor",
    "lider_agentis",
    "gerente_operaciones",
    "tic",
    "gerente_ti",
  ]),
  reporte_eval_desempeno: allowRoles(["desarrollador", "gerente_ti"]),
  evaluacion_visitas: allowRoles(["desarrollador", "jefe_operaciones", "gerente_operaciones", "gerente_general_adjunto"]),
  evaluacion_capacitacion: allowRoles(["fiscal"]),
  asignaciones_capacitador: allowRoles(["capacitador_tecnico", "coordinador_capacitaciones", "jefe_operaciones"]),
  registro_capacitacion: allowRoles(["capacitador_tecnico", "coordinador_capacitaciones"]),
  historial_capacitacion: allowRoles(["capacitador_tecnico", "coordinador_capacitaciones", "fiscal"]),
  // La sección está abierta a todos los cargos: qué recurso ve cada uno lo
  // decide la audiencia que el admin configuró en cada contenido.
  recursos: allowRoles(LEGACY_ROLE_KEYS),
  clima_organizacional: allowRoles(LEGACY_ROLE_KEYS),
  cierre_diario: allowRoles(["fiscal", "jefe_operaciones", "gerente_operaciones"]),
  servicios_especializados: allowRoles(["desarrollador"]),
  nosotros: allowRoles(LEGACY_ROLE_KEYS),
  denuncias: allowRoles(LEGACY_ROLE_KEYS),
  // Solo quienes cargan solicitudes hoy. EMSYS revalida con el permiso
  // solicitudes_rrhh.crear_solicitudes_rrhh, asi que esto es solo el menu.
  // El hub se ve si el usuario tiene al menos un departamento; el default
  // repite los roles de los departamentos que hay.
  // Solicitudes a SST suma a los administrativos: los roles de gerencia/TIC entran
  // al hub (los cargos que no matchean ningun rol ya pasan por defecto).
  // GafCORE abre el hub a todos los cargos menos los operarios.
  solicitudes: allowRoles(TODOS_MENOS_OPERARIO),
  solicitudes_rrhh: allowRoles(["fiscal", "jefe_operaciones", "tic", "desarrollador"]),
  // Gestion de Talento: solicitan fiscales, supervisores y jefes de operaciones;
  // el capacitador tecnico entra a la misma pantalla para cerrar las asignadas.
  solicitudes_capacitacion: allowRoles([
    "fiscal", "supervisor", "jefe_operaciones", "capacitador_tecnico", "desarrollador",
  ]),
  // SST: fiscales, jefes de operaciones y todos los administrativos. Ser
  // administrativo depende del tipo de funcionario (DWH), que la app no conoce:
  // aca solo se excluye a operarios y supervisores, y el resto lo decide EMSYS
  // (solicitudes/permiso, que tambien revalida al crear).
  solicitudes_sst: allowRoles([
    "fiscal", "jefe_operaciones", "gerente_operaciones", "lider_agentis", "tic", "desarrollador",
    "gerente_ti", "gerente_general_adjunto", "capacitador_tecnico", "coordinador_capacitaciones",
  ]),
  // GafCORE: todos los cargos menos los operarios; EMSYS revalida al crear.
  solicitudes_gafcore: allowRoles(TODOS_MENOS_OPERARIO),
};

export const normalizeCargoKey = (cargo?: string | null) => {
  const text = String(cargo || "").trim();
  if (!text) return "";
  return text.toUpperCase();
};

const buildRoleFlags = (cargo?: string | null) => {
  const raw = String(cargo || "");
  const upper = raw.toUpperCase();
  const lower = raw.toLowerCase();
  const includes = (text: string) => upper.includes(text);
  // La gerente de Operaciones hereda los modulos de fiscal y de jefe.
  const esGerenteOps = esGerenteDeOperaciones(raw);

  return {
    operario: lower.includes("operario") || lower.includes("operaria"),
    fiscal: lower.includes("fiscal") || esGerenteOps,
    supervisor: lower.includes("supervisor"),
    jefe_operaciones: includes("JEFE DE OPERACIONES") || includes("JEFE DE OPE") || esGerenteOps,
    gerente_operaciones:
      upper === "GERENTE DE OPERACIONES" || upper === "GERENTE DE OPERACIONES - UNIDADES ESPECIALIZADAS",
    lider_agentis: includes("LIDER AGENTIS") || lower.includes("agentis"),
    // Palabra completa: "TIC" suelto matchearia LOGISTICA, ESTADISTICA, PRACTICANTE.
    tic: /\bTIC\b/.test(upper),
    desarrollador: lower.includes("desarrollador"),
    gerente_ti: includes("GERENTE DE TECNOLOGIAS DE LA INFORMACION"),
    gerente_general_adjunto: lower.includes("gerente general adjunto"),
    capacitador_tecnico: includes("CAPACITADOR TECNICO"),
    coordinador_capacitaciones: includes("COORDINADOR DE CAPACITACIONES TECNICAS"),
  } as Record<LegacyRoleKey, boolean>;
};

const cloneDefaults = () => {
  const out: ModulePermissionsMap = {};
  Object.keys(LEGACY_DEFAULTS).forEach((moduleId) => {
    out[moduleId] = { ...LEGACY_DEFAULTS[moduleId] };
  });
  return out;
};

export const getMergedModulePermissions = (value: unknown): ModulePermissionsMap => {
  const merged = cloneDefaults();

  if (!value || typeof value !== "object") {
    return merged;
  }

  const raw = value as Record<string, Record<string, boolean>>;

  Object.keys(LEGACY_DEFAULTS).forEach((moduleId) => {
    const incoming = raw[moduleId] || {};
    const normalized = { ...LEGACY_DEFAULTS[moduleId] };

    Object.keys(incoming).forEach((key) => {
      if (typeof incoming[key] === "boolean") {
        normalized[key] = Boolean(incoming[key]);
      }
    });

    merged[moduleId] = normalized;
  });

  return merged;
};

export const loadModulePermissions = (): ModulePermissionsMap => {
  try {
    const raw = localStorage.getItem(MODULE_PERMISSIONS_STORAGE_KEY);
    if (!raw) return cloneDefaults();
    return getMergedModulePermissions(JSON.parse(raw));
  } catch {
    return cloneDefaults();
  }
};

export const saveModulePermissions = (permissions: ModulePermissionsMap) => {
  localStorage.setItem(MODULE_PERMISSIONS_STORAGE_KEY, JSON.stringify(permissions));
};

export const getDefaultPermissionForCargo = (moduleId: string, cargo: string) => {
  const defaults = LEGACY_DEFAULTS[moduleId] || {};
  const flags = buildRoleFlags(cargo);

  const matchedLegacy = LEGACY_ROLE_KEYS.filter((key) => flags[key]);
  if (!matchedLegacy.length) return true;

  return matchedLegacy.some((key) => Boolean(defaults[key]));
};

export const expandPermissionsWithCargos = (
  permissions: ModulePermissionsMap,
  cargos: string[]
): ModulePermissionsMap => {
  const merged = getMergedModulePermissions(permissions);

  const normalizedCargos = (cargos || [])
    .map((cargo) => normalizeCargoKey(cargo))
    .filter(Boolean);

  Object.keys(merged).forEach((moduleId) => {
    const modulePerms = { ...merged[moduleId] };

    normalizedCargos.forEach((cargoKey) => {
      if (typeof modulePerms[cargoKey] !== "boolean") {
        modulePerms[cargoKey] = getDefaultPermissionForCargo(moduleId, cargoKey);
      }
    });

    merged[moduleId] = modulePerms;
  });

  return merged;
};

export interface CanViewModuleOptions {
  /**
   * Que devolver cuando el cargo no matchea ningun rol ni tiene override propio.
   * Por defecto true (comportamiento historico); los modulos restringidos a
   * roles puntuales pasan false para no ofrecerle algo que el backend rechaza.
   */
  cargoSinRol?: boolean;
}

export const canViewModule = (
  moduleId: string,
  cargo: string | undefined,
  permissions?: ModulePermissionsMap,
  options?: CanViewModuleOptions
): boolean => {
  const source = permissions || loadModulePermissions();
  const modulePerms = source[moduleId] || LEGACY_DEFAULTS[moduleId];
  if (!modulePerms) return true;

  const cargoKey = normalizeCargoKey(cargo);
  if (cargoKey && typeof modulePerms[cargoKey] === "boolean") {
    return Boolean(modulePerms[cargoKey]);
  }

  const roleFlags = buildRoleFlags(cargo);
  const matchedLegacy = LEGACY_ROLE_KEYS.filter((key) => roleFlags[key]);
  if (matchedLegacy.length) {
    return matchedLegacy.some((key) => Boolean(modulePerms[key]));
  }

  const dynamicKeys = Object.keys(modulePerms).filter((key) => !LEGACY_ROLE_KEYS.includes(key as LegacyRoleKey));
  if (dynamicKeys.length) {
    return false;
  }

  return options?.cargoSinRol ?? true;
};

const getPathname = (path: string) => {
  const clean = String(path || "").split("?")[0].split("#")[0];
  return clean || "/";
};

export const canAccessPath = (
  pathname: string,
  cargo: string | undefined,
  permissions?: ModulePermissionsMap
): boolean => {
  const current = getPathname(pathname);
  const module = MODULE_DEFINITIONS.find((item) =>
    item.paths.some((prefix) => current === prefix || current.startsWith(`${prefix}/`))
  );
  if (!module) return true;
  return canViewModule(module.id, cargo, permissions);
};

export const getModuleByPath = (path: string): ModuleDefinition | undefined => {
  const current = getPathname(path);
  return MODULE_DEFINITIONS.find((item) =>
    item.paths.some((prefix) => current === prefix || current.startsWith(`${prefix}/`))
  );
};
